import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedSection from './components/FeaturedSection';
import StatsSection from './components/StatsSection';
import LatestSection from './components/LatestSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const homeSchema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '布丁漫画',
        url: 'https://budingmanhua.com',
        description: '布丁漫画下拉式阅读专区，提供流畅的下拉式漫画观看体验，免费看韩漫、国漫、日漫全集，支持在线追更。',
        foundingDate: '2019',
        contactPoint: {
          '@type': 'ContactPoint',
          email: 'contact@budingmanhua.com',
          contactType: 'customer service',
        },
      },
      {
        '@type': 'WebSite',
        name: '布丁漫画',
        url: 'https://budingmanhua.com',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://budingmanhua.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: '布丁漫画下拉式看漫画免费 | 下拉式全集韩漫国漫在线追更',
        description: '布丁漫画下拉式阅读专区，提供流畅的下拉式漫画观看体验，免费看韩漫、国漫、日漫全集，支持在线追更，阅读不卡顿一气呵成。',
        url: 'https://budingmanhua.com',
        isPartOf: { '@id': 'https://budingmanhua.com/#website' },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="布丁漫画下拉式看漫画免费 | 下拉式全集韩漫国漫在线追更"
        description="布丁漫画下拉式阅读专区，提供流畅的下拉式漫画观看体验，免费看韩漫、国漫、日漫全集，支持在线追更，阅读不卡顿一气呵成。布丁漫画下拉式看漫画，海量高清漫画资源每日更新。"
        keywords="布丁漫画下拉式看,布丁漫画下拉式漫画,布丁漫画下拉式免费,下拉式阅读,免费漫画,全集漫画,在线追更,韩漫,国漫,布丁漫画网"
        canonicalUrl="https://budingmanhua.com"
        schema={homeSchema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedSection />
        <StatsSection />
        <LatestSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}